jQuery(document).ready(function($) {
		
	// Banner
	
	$('.el-banner').each(function() {
		
		var banners = $(this).find('.el-banner__image');
		var index = 0;
		
		var change = function() {
			
			banners.removeClass('is-visible');
			banners.eq(index).addClass('is-visible');

			index = banners.length - 1 == index ? 0 : index + 1;
			
		}
		
		change();
		setInterval(change, 5000 );
		
	} );
	
	
} );